import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import Login from './Login';
import DBtester from './DBtester'
import ProtectedRoutes from '../../other/ProtectedRoutes';
import { AuthProvider } from '../../other/AuthContext';
import { useEffect } from 'react';
import Register from "./Register";


function App() {


  useEffect(() => {
    document.title = 'Repwise';
  }, []);



  return (
    <div className="App">
      <Router>


        <AuthProvider>


          <Routes>


            <Route path="/" element={<Login />} />
            <Route path="/Register" element={<Register />} />

            <Route element={<ProtectedRoutes />}>



              <Route path="/Home" element={<Home />} />
              <Route path="/DBtester" element={<DBtester />} />

            </Route>



          </Routes>

          
        </AuthProvider>


      </Router>
    </div>
  );
}

export default App;
